import { render } from "./AccountPage.vue?vue&type=template&id=264ed854&scoped=true"
import script from "./AccountPage.vue?vue&type=script&lang=js"
export * from "./AccountPage.vue?vue&type=script&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=264ed854&lang=scss&scoped=true"

import exportComponent from "/home/docker/toodles/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264ed854"]])

export default __exports__